// import { io } from "socket.io-client";

// // const SOCKET_URL = "http://dev.vedvidhi.com:8881";
// const SOCKET_URL = "wss://dev.vedvidhi.com";


// const socket = io(SOCKET_URL, {
//   transports: ["websocket"],
// });

// export default socket;



// src/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = "wss://dev.vedvidhi.com"; 


const socket = io(SOCKET_URL, {
  transports: ["websocket"], 
  reconnection: true, 
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  withCredentials: true, 
});

export default socket;
